'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneVerificationRoute = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _preventDirectServerAccess = require('helpers/preventDirectServerAccess');

var _preventDirectServerAccess2 = _interopRequireDefault(_preventDirectServerAccess);

var _PhoneVerificationOnenter = require('./PhoneVerification.onenter.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};

var PhoneVerificationRoute = exports.PhoneVerificationRoute = function PhoneVerificationRoute(store, client) {
  return {
    path: 'verify-phone',

    onEnter: function onEnter(nextState, replaceState, cb) {
      return store.runSagaOnce(_PhoneVerificationOnenter.phoneVerificationOnEnterSaga, client, nextState, replaceState).done.then(cb, cb);
    },
    getComponent: function getComponent(location, callback) {
      require.ensure([], function (require) {
        callback(null, require('./PhoneVerificationContainer').PhoneVerificationContainer);
      }, 'PhoneVerification');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      var onEnter = (0, _preventDirectServerAccess2.default)(function (loc) {
        return (0, _extends3.default)({}, loc, {
          pathname: loc.pathname.replace('/enter-code', '')
        });
      });

      require.ensure([], function (require) {
        callback(null, [{ path: 'enter-code/**/*', component: require('./CodeVerificationContainer').CodeVerificationContainer, onEnter: onEnter }, { path: '**/*', component: require('./NumberInputContainer').NumberInputContainer }]);
      }, 'PhoneVerification');
    }
  };
};